import styles from "./HeaderLoginButton.module.css"
import { Link } from 'react-router-dom';

function HeaderLoginButton() {
    return (
        <Link className={ styles.button } to="/login">
            Login
        </Link>
    );
}

export default HeaderLoginButton;